import React from 'react';

/**
 * Footer component with location, hours, and contact information
 * Matches the reference design with three-column layout
 */
const Footer = () => {
  // Obfuscate email to protect from spam harvesters
  const emailUser = 'ultimatebarandgrill10';
  const emailDomain = 'gmail.com';

  const handleEmailClick = (e) => {
    e.preventDefault();
    window.location.href = `mailto:${emailUser}@${emailDomain}`;
  };

  return (
    <footer className="bg-black text-white py-16">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-8 text-center">
          {/* Location */}
          <div>
            <h3 className="text-xl font-bold uppercase mb-4 tracking-wide">Location</h3>
            <div className="space-y-1">
              <p>455 East Plaza Drive</p>
              <p>Mooresville, NC</p>
              <p>28115</p>
            </div>
          </div>

          {/* Hours */}
          <div>
            <h3 className="text-xl font-bold uppercase mb-4 tracking-wide">Hours</h3>
            <div className="space-y-2 text-sm">
              <div>
                <p className="font-medium">Mon, Tue, Wed, Thu</p>
                <p>11:00 am - 10:00 pm</p>
              </div>
              <div>
                <p className="font-medium">Fri</p>
                <p>11:00 am - 12:00 am</p>
              </div>
              <div>
                <p className="font-medium">Sat</p>
                <p>12:00 pm - 12:00 am</p>
              </div>
              <div>
                <p className="font-medium">Sun</p>
                <p>12:00 pm - 10:00 pm</p>
              </div>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-xl font-bold uppercase mb-4 tracking-wide">Contact Us</h3>
            <div className="space-y-2">
              <a
                href="tel:+17047999771"
                className="text-lg hover:text-yellow-400 transition-colors duration-300 block"
              >
                (704) 799-9771
              </a>
              <a
                href="tel:+17047999771"
                className="text-lg hover:text-yellow-400 transition-colors duration-300 block mt-2 font-bold"
              >
                Call to Order
              </a>
              <a
                href="#contact"
                onClick={handleEmailClick}
                className="text-lg hover:text-yellow-400 transition-colors duration-300 block"
              >
                {emailUser}&#64;{emailDomain}
              </a>
              <div className="mt-4">
                <p className="font-bold uppercase mb-2 tracking-wide">Find Us On...</p>
                <div className="flex justify-center">
                  <a
                    href="https://www.facebook.com/profile.php?id=100070256190486"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white hover:text-yellow-400 transition-colors duration-300"
                    aria-label="Visit our Facebook page"
                  >
                    <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-white mt-12 pt-8 text-center">
          <p className="text-sm">
            © {new Date().getFullYear()} Ultimate Bar & Grill. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
